import React from "react";

const SendIcon = () => (
  <svg viewBox="0 0 100 100">
    <path d="M.048 92.714L100 49.857.048 7 0 40.333l71.429 9.524L0 59.381z" />
  </svg>
);

export default SendIcon;
